export default __webpack_public_path__ + "static/media/azure.8de88c1c.png";